var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('reviews-summary-unified')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }